/// <reference path="_references.js" />

if (isNullOrUndefined(veritracks.data)) {
    /** @namespace */
    veritracks.data = {};
}
/** @namespace */
veritracks.data.DataController = function () {
    var self = this,
        mRequestId = 0,
        mRequestHash = {};

    function getRequestId() {
        return mRequestId++;
    }

    function setRequest(aRequestId, aRequest) {
        mRequestHash[aRequestId] = aRequest;
    }

    function getRequest(aRequestId) {
        var lRequest = null;
        if (!isNullOrUndefined(mRequestHash[aRequestId])) {
            lRequest = mRequestHash[aRequestId];
        }
        return lRequest;
    }

    function clearRequest(aRequestId) {
        mRequestHash[aRequestId] = null;
    }

    this.cancelRequest = function (aRequestId) {
        var lRequest = getRequest(aRequestId);
        if (lRequest !== null) {
            lRequest.abort();
            clearRequest(aRequestId);
        }
    };

    this.readMultiple = function (aFullTypeName, aExpression, aVersion, aOnSuccess, aOnFailure, aOutParams, aSortExpression, aRecordCount, aDoCheckState) {
        var lSortExpression = null,
            lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRecordCount = -1,
            lDoCheckState = true,
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (lSecurityToken) {

            if (!isNullOrUndefined(aSortExpression)) {
                lSortExpression = aSortExpression;
            }
            if (!isNullOrUndefined(aRecordCount)) {
                lRecordCount = aRecordCount;
            }
            if (!isNullOrUndefined(aDoCheckState)) {
                lDoCheckState = aDoCheckState;
            }

            lRequest = callAjax('ReadMultiple', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aTypeName': aFullTypeName,
                'aVersion': aVersion,
                'aWrappedExpression': { 'Expression': aExpression },
                'aSortExpression': lSortExpression,
                'aHowMany': lRecordCount
            }, success, failure, aOutParams, lDoCheckState);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.readTripsAndVisits = function (aEnrolleeId, aIsHistoricalTrackDate, aStartDate, aEndDate, aUpdateFlag, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            lRequest = callAjax('ReadTripsVisits', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aEnrolleeId': aEnrolleeId,
                'aIsHistoricalTrackDate': aIsHistoricalTrackDate,
                'aStartDate': aStartDate.toWcf(),
                'aEndDate': aEndDate.toWcf(),
                'aUpdateFlag': aUpdateFlag,
                'aGetAddress': true
            }, success, failure, aOutParams);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.readEnrolleeTimeline = function (aEnrolleeId, aStartDate, aEndDate, aIsCached, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            lRequest = callAjax('ReadEnrolleeTimeline', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aEnrolleeId': aEnrolleeId,
                'aStartDate': aStartDate.toWcf(),
                'aEndDate': aEndDate.toWcf(),
                'aIsCached': aIsCached
            }, success, failure, aOutParams);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.readEnrolleeIncidentTrackpoints = function (aLatitude, aLongitude, aRadius, aStartDate, aEndDate, aEnrolleeId, aIncidentId, aIncidentMatchId, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            lRequest = callAjax('ReadEnrolleeIncidentTrackpoints', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aLatitude': aLatitude,
                'aLongitude': aLongitude,
                'aRadius': aRadius,
                'aStartDate': aStartDate.toWcf(),
                'aEndDate': aEndDate.toWcf(),
                'aEnrolleeId': aEnrolleeId,
                'aIncidentId': aIncidentId,
                'aIncidentMatchId': aIncidentMatchId,
            }, success, failure, aOutParams);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.readDeviceAssignments = function (aStartDate, aEndDate, aDeviceIdList, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            lRequest = callAjax('ReadDeviceAssignments', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aStartDate': aStartDate.toWcf(),
                'aEndDate': aEndDate.toWcf(),
                'aDeviceIdList': aDeviceIdList
            }, success, failure, aOutParams);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.testTimeline = function () {
        var lSortExpression = null,
            lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRecordCount = -1,
            lDoCheckState = true,
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (lSecurityToken) {


            lRequest = callAjax('TestTimeline', {
                'aSecurityToken': lSecurityToken
            }, success, failure, [], true);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.readEnrolleeEvents = function (aEnrolleeId, aStartDate, aEndDate, aMetaEventIdList, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            lRequest = callAjax('ReadEnrolleeEvents', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aEnrolleeId': aEnrolleeId,
                'aStartDate': aStartDate.toWcf(),
                'aEndDate': aEndDate.toWcf(),
                'aMetaEventIdList': aMetaEventIdList
            }, success, failure, aOutParams);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.buildGraph = function (aGraph, aOutParams, aOnSuccess) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            lRequest = callAjaxTest('BuildGraph', aGraph, success, failure, aOutParams);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.readDeviceBattery = function (aDeviceId, aMonth, aDay, aYear, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            lRequest = callAjax('GetDeviceBatteryInformation', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aDeviceId': aDeviceId,
                'aMonth': aMonth,
                'aDay': aDay,
                'aYear': aYear,
                'aTimeZone': moment.tz.guess()
            }, success, failure, aOutParams);
            setRequest(lRequestId, lRequest);
        }

        return lRequestId;
    };

    this.addRegularSchedule = function (aSchedule, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            return callAjax('AddRegularSchedules', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aSchedule': prepareObjectForWcf(aSchedule)
            }, success, failure, aOutParams);
            //setRequest(lRequestId, lRequest);
        }
    };

    this.Is2FARequired = function (aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            return callAjax('Is2FARequired', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
            }, success, failure, aOutParams);
        }
    };

    this.Generate2FactorAuthSecret = function (aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            return callAjax('Generate2FactorAuthSecret', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
            }, success, failure, aOutParams);
        }
    };

    this.Generate2Factor10Codes = function (aUserId, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            return callAjax('Generate2FAHotp', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aUserId': aUserId
            }, success, failure, aOutParams);
        }
    };

    this.Enable2FA = function (aSecret, aCode, aOnSuccess, aOnFailure, aOutParams) {
        var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRequestId = getRequestId(),
            lRequest;

        function success(aOutParams, aData, aState) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnSuccess)) {
                aOnSuccess(aOutParams, aData, aState);
            }
        }

        function failure(XMLHttpRequest, textStatus, errorThrown) {
            clearRequest(lRequestId);
            if (!isNullOrUndefined(aOnFailure)) {
                aOnFailure(XMLHttpRequest, textStatus, errorThrown);
            }
        }

        if (!isNullOrUndefined(lSecurityToken)) {
            return callAjax('Enable2FA', {
                'aSecurityToken': lSecurityToken,
                'aSecurityContextId': -1,
                'aSecret': aSecret,
                'aCode': aCode
            }, success, failure, aOutParams);
        }
    };
};
veritracks.data.controller = new veritracks.data.DataController();


function ReleaseLockMultiple(aFullTypeName, aIdList, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        // callAjax("ReleaseLockMultiple", { 'aTypeName': aFullTypeName, 'aIdList': aIdList }, aOnSuccess, aOnFailure, aOutParams);
        aOnSuccess();
    }
}

function ReleaseLockSingle(aFullTypeName, aId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        // callAjax("ReleaseLockSingle", { 'aTypeName': aFullTypeName, 'aId': aId }, aOnSuccess, aOnFailure, aOutParams);
        aOnSuccess();
    }
}

function ExtendLockMultiple(aFullTypeName, aIdList, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        // callAjax("ExtendLockMultiple", { 'aTypeName': aFullTypeName, 'aIdList': aIdList }, aOnSuccess, aOnFailure, aOutParams);
        aOnSuccess();
    }
}

function ExtendLockSingle(aFullTypeName, aId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        // callAjax("ExtendLockSingle", { 'aTypeName': aFullTypeName, 'aId': aId }, aOnSuccess, aOnFailure, aOutParams);
        aOnSuccess();
    }
}

function LockMultiple(aFullTypeName, aIdList, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        // callAjax("LockMultiple", { 'aTypeName': aFullTypeName, 'aIdList': aIdList }, aOnSuccess, aOnFailure, aOutParams);
        aOnSuccess();
    }
}

function LockSingle(aFullTypeName, aId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        // callAjax("LockSingle", { 'aTypeName': aFullTypeName, 'aId': aId }, aOnSuccess, aOnFailure, aOutParams);
        aOnSuccess();
    }
}

function ExtendServerSession(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('ExtendSession', { 'aSecurityToken': lSecurityToken }, aOnSuccess, aOnFailure, aOutParams);
    }
}

function ExpireServerSession(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('ExpireSession', { 'aSecurityToken': lSecurityToken }, aOnSuccess, aOnFailure, aOutParams);
    }
}

function IsAuthorized(aSecurityContextId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('IsAuthorized', { 'aSecurityToken': lSecurityToken, 'aSecurityContextId': aSecurityContextId }, aOnSuccess, aOnFailure, aOutParams);
    }
}

function WriteMultiple(aObjectList, aOnSuccess, aOnFailure, aOutParams, aIsPersist, aIsAsync) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
        lKey,
        lIsPersist = true,
        lIsAsync = false;

    if (!isNullOrUndefined(aIsAsync)) {
        lIsAsync = aIsAsync;
    }
    if (!isNullOrUndefined(aIsPersist)) {
        lIsPersist = aIsPersist;
    }
    for (lKey in aObjectList) {
        if (aObjectList.hasOwnProperty(lKey)) {
            aObjectList[lKey] = prepareObjectForWcf(aObjectList[lKey]);
        }
    }
    if (!isNullOrUndefined(lSecurityToken)) {
        return callAjax('WriteMultiple', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aObjectList': { 'Data': aObjectList },
            'aPersist': lIsPersist,
            'aAsync': lIsAsync
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function Execute(aObject, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('Execute', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aProcedureParameterDefinition': { 'Data': prepareObjectForWcf(aObject) }
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function WriteSingle(aObject, aOnSuccess, aOnFailure, aOutParams, aIsPersist) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
        lIsPersist = true;
    if (!isNullOrUndefined(aIsPersist)) {
        lIsPersist = aIsPersist;
    }
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteSingle', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aObject': { 'Data': prepareObjectForWcf(aObject) },
            'aPersist': lIsPersist,
            'aAsync': false
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function WriteUserSMSDeliveryMethod(aUser, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteUserSMSDeliveryMethod', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUser': prepareObjectForWcf(aUser)
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

//function ReadSingle(aFullTypeName, aId, aVersion, aOnSuccess, aOnFailure, aOutParams) {
//    "use strict";
//    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
//    if (!isNullOrUndefined(lSecurityToken)) {
//        callAjax('ReadSingle', {
//            'aSecurityToken': lSecurityToken,
//            'aSecurityContextId': -1,
//            'aTypeName': aFullTypeName,
//            'aVersion': aVersion,
//            'aId': aId
//        }, aOnSuccess, aOnFailure, aOutParams, true);
//    }
//}

function ReadMultiple(aFullTypeName, aExpression, aVersion, aOnSuccess, aOnFailure, aOutParams, aSortExpression, aRecordCount, aDoCheckState) {
    "use strict";
    return veritracks.data.controller.readMultiple(aFullTypeName, aExpression, aVersion, aOnSuccess, aOnFailure, aOutParams, aSortExpression, aRecordCount, aDoCheckState);
    //var lSortExpression = null,
    //    lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
    //    lRecordCount = -1,
    //    lDoCheckState = true;
    //if (!isNullOrUndefined(lSecurityToken)) {

    //    if (!isNullOrUndefined(aSortExpression)) {
    //        lSortExpression = aSortExpression;
    //    }
    //    if (!isNullOrUndefined(aRecordCount)) {
    //        lRecordCount = aRecordCount;
    //    }
    //    if (!isNullOrUndefined(aDoCheckState)) {
    //        lDoCheckState = aDoCheckState;
    //    }

    //    callAjax('ReadMultiple', {
    //        'aSecurityToken': lSecurityToken,
    //        'aSecurityContextId': -1,
    //        'aTypeName': aFullTypeName,
    //        'aVersion': aVersion,
    //        'aWrappedExpression': { 'Expression': aExpression },
    //        'aSortExpression': lSortExpression,
    //        'aHowMany': lRecordCount
    //    }, aOnSuccess, aOnFailure, aOutParams, lDoCheckState);
    //}
}

function query(aHash, aExpression) {
    "use strict";

    var lResult,
        lKey,
        lItem;
    if (!isNullOrUndefined(aHash) && !isNullOrUndefined(aExpression)) {
        lResult = [];
        for (lKey in aHash) {
            if (aHash.hasOwnProperty(lKey)) {
                lItem = aHash[lKey];
                // Check if the expression has an Evaluate method before calling it
                if (typeof aExpression.Evaluate === 'function' && aExpression.Evaluate(lItem)) {
                    lResult[lKey] = lItem;
                }
            }
        }
    } else {
        lResult = aHash;
    }
    return lResult;

    //    var lDebug = [];
    //    var lList = $.grep(aArray, function (aObject, aIndex) {
    //        HitThis(aArray, aExpression, aObject, aIndex);
    //        var lReturn = aExpression.ToString("aObject");
    //        lDebug.push(aObject);
    //        return eval(lReturn);
    //    });
}

function CheckSessions(aUserId, aSecurityToken,aOnSuccess, aOnFailure) {
    "use strict";
    var lSortExpression = null,
            lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRecordCount = -1,
            lDoCheckState = true,
            lRequestId = -1,
            lRequest;

    function success(aOutParams, aData, aState) {

        if (!isNullOrUndefined(aOnSuccess)) {
            aOnSuccess(aOutParams, aData, aState);
        }
    }

    function failure(XMLHttpRequest, textStatus, errorThrown) {
        if (!isNullOrUndefined(aOnFailure)) {
            aOnFailure(XMLHttpRequest, textStatus, errorThrown);
        }
    }

    if (lSecurityToken) {
        lRequest = callAjax('CheckSessions', { 'aUserId': aUserId, 'aSecurityToken': decodeURIComponent(aSecurityToken) }, success, failure, null, lDoCheckState);
    }

    return lRequest;
}

function LogUserAgreement(aUserLogId, aAgreementFlag, aOnSuccess, aOnFailure) {
    "use strict";
    var lSortExpression = null,
            lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
            lRecordCount = -1,
            lDoCheckState = true,
            lRequestId = -1,
            lRequest;

    function success(aOutParams, aData, aState) {

        if (!isNullOrUndefined(aOnSuccess)) {
            aOnSuccess(aOutParams, aData, aState);
        }
    }

    function failure(XMLHttpRequest, textStatus, errorThrown) {
        if (!isNullOrUndefined(aOnFailure)) {
            aOnFailure(XMLHttpRequest, textStatus, errorThrown);
        }
    }

    if (lSecurityToken) {
        lRequest = callAjax('LogUserAgreement', { 'aUserLoginLogId': aUserLogId, 'aAgreementFlag': aAgreementFlag }, success, failure, null, lDoCheckState);
    }

    return lRequest;
}

function GetBillingInfo(aQuery, aConnection, aOnSuccess, aOnFailure, aOutParams, lDoCheckState) {
    "use strict";
    callAjax('GetBillingInfo', {
        'EnrolleeIds': aQuery,
        'Schema': aConnection
    }, aOnSuccess, aOnFailure, aOutParams, lDoCheckState);
}

function RefreshCacheItem(aFullTypeName) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('RefreshCacheItem', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aTypeName': aFullTypeName
        }, null, null, null, false);
    }

}


function WriteGlobalZone(aZone, aZoneVertexes, aOnSuccess, aOnFailure) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteGlobalZone', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aZone': aZone,
            'aZoneVertexes': aZoneVertexes
        }, aOnSuccess, aOnFailure, null);
    }
}

function WriteGlobalZonePQ(aZone, aOnSuccess, aOnFailure) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteGlobalZoneProcessRequest', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aZone': aZone
        }, aOnSuccess, aOnFailure, null);
    }

}

function UpdateZones(aZoneList, aOnSuccess, aOnFailure) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('UpdateZones', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aZones': aZoneList
        }, aOnSuccess, aOnFailure, null);
    }

}

function WriteVictimDeviceUnAssignment(aVictim, aVictimDevice, aOffenderDevice, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteVictimDeviceUnAssignment', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aVictim': aVictim,
            'aVictimDevice': aVictimDevice,
            'aOffenderDevice': aOffenderDevice
        }, aOnSuccess, aOnFailure, aOutParams);
    }
}

function WriteVictimDeviceUnAssignmentPR(aVictim, aVictimDevice, aOffenderDevice, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteVictimDeviceUnAssignmentPR', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aVictim': aVictim,
            'aVictimDevice': aVictimDevice,
            'aOffenderDevice': aOffenderDevice
        }, aOnSuccess, aOnFailure, aOutParams);
    }
}

function WriteVictimDeviceAssignment(aVictim, aVictimDevice, aOffenderDevice, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteVictimDeviceAssignment', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aVictim': aVictim,
            'aVictimDevice': aVictimDevice,
            'aOffenderDevice': aOffenderDevice
        }, aOnSuccess, aOnFailure, aOutParams);
    }
}

function WriteVictimDeviceAssignmentPR(aVictim, aVictimDevice, aOffenderDevice, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();

    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteVictimDeviceAssignmentPR', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aVictim': aVictim,
            'aVictimDevice': aVictimDevice,
            'aOffenderDevice': aOffenderDevice
        }, aOnSuccess, aOnFailure, aOutParams);
    }
}

function GetObjectList(aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetObjectList', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1
        }, aOnSuccess, aOnFailure, aOutParams, true);
    }
}

function WriteUserPassword(aUserId, aPassword, aNewPassword, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('AgentUpdatePassword', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserId': aUserId,
            'aPassword': aPassword,
            'aNewPassword': aNewPassword
        }, aOnSuccess, aOnFailure, aOutParams, true);
    }
}

function WriteLogUserTransaction(aUserTransaction, aUserTransactionValues, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('LogUserTransaction', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aUserTransaction': aUserTransaction,
            'aUserTransactionValues': aUserTransactionValues.map(function (value) { return prepareObjectForWcf (value)})
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetBluHomeCommandStatus(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetBluHomeCommandStatus', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetEMAEnrolleeStatus(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEMAEnrolleeStatus', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetEMACheckInSchedule(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEMACheckInSchedule', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetEMAChangeRequest(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEMAChangeRequest', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}
function GetEMAMessagePending(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEMAMessagePending', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId,
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}
function GetEMACheckInEvent(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEMACheckInEvent', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}
function GetAgentNotificationPending(aCtUserId,aFilter,aPageNumber, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetAgentNotificationPending', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aCtUserId': aCtUserId,
            'aFilter': aFilter,
            'aPageNumber': aPageNumber,
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetPlacesRequest(aLatitude, aLongitude, aRadius, aQuery, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetPlacesRequest', {
            'aSecurityToken': lSecurityToken,
            'aLatitude': aLatitude,
            'aLongitude': aLongitude,
            'aRadius': aRadius,
            'aQuery': aQuery
        }, function (a, b) {
            aOnSuccess(a, JSON.parse(b))
        }, aOnFailure, aOutParams, false);
    }
}

function GetRefreshedZones(aIds, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetZones', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aIds': aIds
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}
function WriteEnrolleeAudibleOnLowBatt(aEnrolleeId, aDeviceId,aUserId,aAudibleToneFLag, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('WriteEnrolleeAudibleOnLowBatt', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aId': aEnrolleeId,
            'aDeviceId': aDeviceId,
            'aUserId': aUserId,
            'aAudibleToneFLag': aAudibleToneFLag
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}
function GetEIdReservationQuota(aEnrolleeId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetEIdReservationQuota', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetIcons(aId, aGetAll, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetIcons', {
            'aSecurityToken': lSecurityToken,
            'aId': aId,
            'aGetAll': aGetAll
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GenerateIconsPng(aIconList, aOnSuccess, aOnFailure, aOutParams, aByPass) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    //bypass the call to GenerateIconsPng
    if (!isNullOrUndefined(aByPass) && aByPass == true) {
        aOnSuccess(aOutParams, []);
    } else {
        if (!isNullOrUndefined(lSecurityToken)) {
            callAjax('GenerateIconsPng', {
                'aSecurityToken': lSecurityToken,
                'aIconList': aIconList,
            }, aOnSuccess, aOnFailure, aOutParams, false);
        }
    }   
}

function GetOffenderAlcoholLastTest(aOriList, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetOffenderAlcoholLastTest', {
            'aSecurityToken': lSecurityToken,
            'aOriList': aOriList
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function ReverseGeoCodeAddress(aLatitude, aLongitude, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('ReverseGeoCodeAddress', {
            'aSecurityToken': lSecurityToken,
            'aLatitude': aLatitude,
            'aLongitude': aLongitude,
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GeoCodeAddress(aDescription, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GeoCodeAddress', {
            'aSecurityToken': lSecurityToken,
            'aDescription': aDescription,
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetOffenderAlcoholSchedules(aEnrolleeId, aScheduleId, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetOffenderAlcoholSchedules', {
            'aSecurityToken': lSecurityToken,
            'aEnrolleeId': aEnrolleeId,
            'aScheduleId': aScheduleId
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}


function GetOriDeviceChangeReason(aOriList, aEnrolleeType, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetOriDeviceChangeReason', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aOriList': aOriList,
            'aEnrolleeType': aEnrolleeType,
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetOriSexOffense(aOriList, aOnSuccess, aOnFailure, aOutParams) {
    "use strict";
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetOriSexOffense', {
            'aSecurityToken': lSecurityToken,
            'aOriList': aOriList
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetDeviceContact(aDeviceId, aContactDate, aOnSuccess, aOnFailure, aOutParams, aGetMoreData){
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax('GetDeviceContact', {
            'aSecurityToken': lSecurityToken,
            'aDeviceId': aDeviceId,
            'aGetMoreData': aGetMoreData,
            'aContactDate': aContactDate,
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

function GetNonCacheItem(aTypeName, aOriList, aOnSuccess, aOnFailure, aOutParams){
    var lSecurityToken = veritracks.security.controller.tryGetSecurityToken();
    if (!isNullOrUndefined(lSecurityToken)) {
        callAjax(aTypeName, {
            'aSecurityToken': lSecurityToken,
            'aOriList': aOriList
        }, aOnSuccess, aOnFailure, aOutParams, false);
    }
}

Date.prototype.toWcf = function () {
    "use strict";
    var lMilliseconds = this.getTime(),
        lReturn = '/Date(' + lMilliseconds + ')/';
    if (isNaN(lMilliseconds)) {
        lReturn = '/Date(0)/';
    }
    return lReturn;
};

Date.prototype.addYears = function (aYears) {
    "use strict";
    this.setYear(this.getFullYear() + aYears);
    return this;
};

Date.prototype.addDays = function (aDays) {
    "use strict";
    this.setDate(this.getDate() + aDays);
    return this;
};

Date.prototype.addHours = function (aHours) {
    "use strict";
    this.setHours(this.getHours() + aHours);
    return this;
};

Date.prototype.addMinutes = function (aMinutes) {
    "use strict";
    this.setMinutes(this.getMinutes() + aMinutes);
    return this;
};

Number.prototype.toWholeString = function (aPrecision) {
    "use strict";
    var lResult = this.toString();
    while (lResult.length < aPrecision) {
        lResult = '0' + lResult;
    }
    return lResult;
};

Array.prototype.move = function (aCurrentIndex, aNewIndex) {
    if (aNewIndex >= this.length) {
        var k = aNewIndex - this.length;
        while ((k--) + 1) {
            this.push(undefined);
        }
    }
    this.splice(aNewIndex, 0, this.splice(aCurrentIndex, 1)[0]);
    return this; // for testing purposes
};

Array.prototype.remove = function (aStartIndex, aEndIndex) {
    var rest = this.slice((aEndIndex || aStartIndex) + 1 || this.length);
    this.length = aStartIndex < 0 ? this.length + aStartIndex : aStartIndex;
    return this.push.apply(this, rest);
};

Array.prototype.unique = function () {
    var o = {}, i, l = this.length, r = [];
    for (i = 0; i < l; i += 1) o[this[i]] = this[i];
    for (i in o) r.push(o[i]);
    return r;
};

function FixDates(aList) {
    "use strict";
    var lProperty,
        lKey,
        lList,
        lDateProperties = [],
        lDatePropIndex = -1,
        lDataPropLength = 0,
        lItem,
        lPropertyValue;
    if (!isNullOrUndefined(aList)) {
        if (!(aList instanceof Array)) {
            lList = [];
            lList.push(aList);
        } else {
            lList = aList;
        }
        if (lList.length > 0) {
            for (lKey in lList) {
                if (lList.hasOwnProperty(lKey)) {
                    lItem = lList[lKey];
                    var l = '';
                    for (lProperty in lItem) {
                        if (lItem.hasOwnProperty(lProperty)) {
                            lPropertyValue = lItem[lProperty];
                            if (typeof lPropertyValue === 'string') {
                                if (lPropertyValue.indexOf('/Date') !== -1) {
                                    lDateProperties[++lDatePropIndex] = lProperty;
                                }
                            }
                        }
                    }
                    // only run for first item in the data list
                    break;
                }
            }

            if (lDatePropIndex > -1) {
                lDataPropLength = lDateProperties.length;
                for (lKey in lList) {
                    if (lList.hasOwnProperty(lKey)) {
                        lItem = lList[lKey];
                        for (lDatePropIndex = 0; lDatePropIndex < lDataPropLength; lDatePropIndex++) {
                            lItem[lDateProperties[lDatePropIndex]] = fixDate(lItem[lDateProperties[lDatePropIndex]]);
                        }
                    }
                }
            }
        }
    }
}

function fixDate(aWcfDateString) {
    var lResult = aWcfDateString,
        lOffset,
        lMilliseconds,
        lTimeSplit,
        lMillisecondsIndex = 0,
        lMillisecondsRegEx = /\/Date\(/gi,
        lOffsetRegEx = /\)\//gi;

    lMillisecondsRegEx.compile(lMillisecondsRegEx);
    lOffsetRegEx.compile(lOffsetRegEx);
    if (!isNullOrUndefined(aWcfDateString) && (typeof aWcfDateString === "string")) {
        lOffset = '0';
        lMillisecondsIndex = 0;
        lTimeSplit = aWcfDateString.split('-');
        if (!isNullOrUndefined(lTimeSplit[2])) {
            lMillisecondsIndex = 1;
        } else {
            if (lTimeSplit[lMillisecondsIndex] === "/Date(") {
                lMillisecondsIndex = 1;
            }
            lTimeSplit[lMillisecondsIndex] = lTimeSplit[lMillisecondsIndex].replace(lOffsetRegEx, '');
        }
        lMilliseconds = lTimeSplit[lMillisecondsIndex];
        if (!isNullOrUndefined(lTimeSplit[lMillisecondsIndex + 1])) {
            lOffset = lTimeSplit[lMillisecondsIndex + 1];
        }
        lMilliseconds = parseInt(lMilliseconds.replace(lMillisecondsRegEx, ''));
        if (lMillisecondsIndex === 1) {
            lMilliseconds = 0 - lMilliseconds;
        }
        lOffset = parseInt(lOffset.replace(lOffsetRegEx, ''));
        // * 10 instead of 1000 becaue offset will be 0400 indicating 4 hours
        // lItem[lDateProperties[lDatePropIndex]] = new Date(lMilliseconds - (lOffset * 60 * 60 * 1000));
        try {
            lResult = new Date(lMilliseconds - (lOffset * 60 * 60 * 10));
            //check for invalid date
            if (Object.prototype.toString.call(lResult) == "[object Date]") {
                if (isNaN(lResult.getTime())) {
                    lResult = aWcfDateString;
                }
            }
        } catch (err) {
            lResult = aWcfDateString;
        }        
    }


    // potential fix ---- remove all replace with ->     return moment(moment(aWcfDateString)).zone(moment(aWcfDateString).format('Z'))._d;
    return lResult;
}

function prepareObjectForWcf(aObject) {
    var lNewObject = $.extend({}, aObject),
        lProperty,
        lValue,
        lMatch = /date/i;

    lMatch.compile(lMatch);
    for (lProperty in aObject) {
        if (aObject.hasOwnProperty(lProperty)) {
            lValue = aObject[lProperty];
            if (typeof lValue === 'object' && (!isNullOrUndefined(lValue)) && (!isNullOrUndefined(lValue.constructor.toString().match(lMatch)))) {
                lNewObject[lProperty] = lValue.toWcf();
            }
            if (lProperty === "IsActive") {
                lNewObject[lProperty] = lValue ? 1 : 0;
            }
        }
    }
    return lNewObject;
}

///////////////////////////////////////////////////////////////////////////////////////////////////////
// SerializationSettings
///////////////////////////////////////////////////////////////////////////////////////////////////////

function SerializationSettings(aExpression, aSortExpression, aPageNumber, aItemsPerPage) {
    "use strict";
    this.Expression = aExpression;
    this.SortExpression = aSortExpression;
    this.PageNumber = aPageNumber;
    this.ItemsPerPage = aItemsPerPage;
}




///////////////////////////////////////////////////////////////////////////////////////////////////////
// Filter
///////////////////////////////////////////////////////////////////////////////////////////////////////
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (needle) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] === needle) {
                return i;
            }
        }
        return -1;
    };
}

function GrepExample(aArray, aExpression) {
    "use strict";
    // only works with arrays, not with hash
    return $.grep(aArray, aExpression.Evaluate);
}

function LogicalOperatorEnum() {
    "use strict";
    this.Undefined = function () { return -1; };
    this.And = function () { return 1; };
    this.Or = function () { return 2; };
}
var mLogicalOperatorEnum = new LogicalOperatorEnum();

function RelationalOperatorEnum() {
    "use strict";

    this.Undefined = function () { return -1; };
    this.Equal = function () { return 1; };
    this.NotEqual = function () { return 2; };
    this.Like = function () { return 3; };
    this.GreaterThan = function () { return 4; };
    this.GreaterThanOrEqual = function () { return 5; };
    this.LessThan = function () { return 6; };
    this.LessThanOrEqual = function () { return 7; };
    this.Is = function () { return 8; };
    this.IsNot = function () { return 9; };
    this.In = function () { return 10; };
    this.NotIn = function () { return 11; };
    this.Contains = function () { return 12; };
}
var mRelationalOperatorEnum = new RelationalOperatorEnum();

function ExpressionBinary(aLeftOperand, aRightOperand, aLogicalOperator) {
    "use strict";

    // this section defined by .net - items must be sent alphabetically
    this.__type = "ExpressionBinary:www.sumosoftware.com/Expressions";
    this.LeftOperand = aLeftOperand;
    this.Operator = aLogicalOperator;
    this.RightOperand = aRightOperand;

    this.Evaluate = function (aObject) {
        var lResult = this.LeftOperand.Evaluate(aObject),
            lRightResult;
        if (this.Operator === mLogicalOperatorEnum.And()) {
            // only evaluate the right if the left is true when logical op is AND
            if (lResult === true && this.RightOperand !== null) {
                lRightResult = this.RightOperand.Evaluate(aObject);
                lResult = lResult && lRightResult;
            }
        } else {
            // only evaluate the right if the left is false when logical op is OR
            if (lResult === false && this.RightOperand !== null) {
                lRightResult = this.RightOperand.Evaluate(aObject);
                lResult = lResult || lRightResult;
            }
        }
        return lResult;
    };
}

function ExpressionConditional(aName, aValue, aIsLiteral, aRelationalOperator) {
    "use strict";

    var lLocalisNullOrUndefined = isNullOrUndefined,
        lFunc = null;
        //lFunctionTable = [];

    // this section defined by .net - items must be sent alphabetically
    this.__type = "ExpressionConditional:www.sumosoftware.com/Expressions";
    this.IsLiteral = false;
    if (!lLocalisNullOrUndefined(aIsLiteral)) {
        this.IsLiteral = aIsLiteral;
    }
    this.Name = aName;
    if (isNullOrUndefined(aRelationalOperator)) {
        aRelationalOperator = mRelationalOperatorEnum.Equal();
    }
    this.Operator = aRelationalOperator;
    this.Value = aValue;

    // evaluation functions
    function EqualFunc(aDatasetValue, aComparison) {
        return aDatasetValue == aComparison;
    }

    function NotEqualFunc(aDatasetValue, aComparison) {
        return aDatasetValue != aComparison;
    }

    function LikeFunc(aDatasetValue, aComparison) {
        // http://stackoverflow.com/questions/5324798/how-to-search-an-array-in-jquery-like-sql-like-value-statement

        var lResult = !lLocalisNullOrUndefined(aDatasetValue),
            lDatasetValue,
            lComparison;
        if (lResult === true) {
            lDatasetValue = aDatasetValue.toString().toLowerCase();
            lComparison = aComparison.toString().toLowerCase();
            lResult = lDatasetValue.indexOf(lComparison) !== -1;
        }

        return lResult;
    }

    function GreaterThanFunc(aDatasetValue, aComparison) {
        return !lLocalisNullOrUndefined(aDatasetValue) && aDatasetValue > aComparison;
    }

    function GreaterThanOrEqualFunc(aDatasetValue, aComparison) {
        return !lLocalisNullOrUndefined(aDatasetValue) && aDatasetValue >= aComparison;
    }

    function LessThanFunc(aDatasetValue, aComparison) {
        return !lLocalisNullOrUndefined(aDatasetValue) && aDatasetValue < aComparison;
    }

    function LessThanOrEqualFunc(aDatasetValue, aComparison) {
        return !lLocalisNullOrUndefined(aDatasetValue) && aDatasetValue <= aComparison;
    }

    function IsFunc(aDatasetValue, aComparison) {
        return aDatasetValue === aComparison;
    }

    function IsNotFunc(aDatasetValue, aComparison) {
        return aDatasetValue !== aComparison;
    }

    function InFunc(aDatasetValue, aComparison) {
        return !lLocalisNullOrUndefined(aDatasetValue) &&
            (aComparison.indexOf(aDatasetValue) !== -1 ||
            aComparison.indexOf(aDatasetValue.toString()) !== -1);
    }

    function NotInFunc(aDatasetValue, aComparison) {
        return !lLocalisNullOrUndefined(aDatasetValue) &&
            aComparison.indexOf(aDatasetValue) === -1 &&
            aComparison.indexOf(aDatasetValue.toString()) === -1;
    }

    function ContainsFunc(aDatasetValue, aComparison) {
        return !lLocalisNullOrUndefined(aDatasetValue) &&
            (aDatasetValue.indexOf(aComparison) !== -1 ||
            aDatasetValue.indexOf(aComparison.toString()) !== -1);
    }
    // table for fast lookup of functions - faster than switch?
    //    lFunctionTable[mRelationalOperatorEnum.Equal()] = EqualFunc;
    //    lFunctionTable[mRelationalOperatorEnum.NotEqual()] = NotEqualFunc;
    //    lFunctionTable[mRelationalOperatorEnum.Like()] = LikeFunc;
    //    lFunctionTable[mRelationalOperatorEnum.GreaterThan()] = GreaterThanFunc;
    //    lFunctionTable[mRelationalOperatorEnum.GreaterThanOrEqual()] = GreaterThanOrEqualFunc;
    //    lFunctionTable[mRelationalOperatorEnum.LessThan()] = LessThanFunc;
    //    lFunctionTable[mRelationalOperatorEnum.LessThanOrEqual()] = LessThanOrEqualFunc;
    //    lFunctionTable[mRelationalOperatorEnum.Is()] = IsFunc;
    //    lFunctionTable[mRelationalOperatorEnum.IsNot()] = IsNotFunc;
    //    lFunctionTable[mRelationalOperatorEnum.In()] = InFunc;
    //    lFunctionTable[mRelationalOperatorEnum.NotIn()] = NotInFunc;


    switch (this.Operator) {
        case mRelationalOperatorEnum.Equal():
            lFunc = EqualFunc;
            break;
        case mRelationalOperatorEnum.NotEqual():
            lFunc = NotEqualFunc;
            break;
        case mRelationalOperatorEnum.Like():
            lFunc = LikeFunc;
            break;
        case mRelationalOperatorEnum.GreaterThan():
            lFunc = GreaterThanFunc;
            break;
        case mRelationalOperatorEnum.GreaterThanOrEqual():
            lFunc = GreaterThanOrEqualFunc;
            break;
        case mRelationalOperatorEnum.LessThan():
            lFunc = LessThanFunc;
            break;
        case mRelationalOperatorEnum.LessThanOrEqual():
            lFunc = LessThanOrEqualFunc;
            break;
        case mRelationalOperatorEnum.Is():
            lFunc = IsFunc;
            break;
        case mRelationalOperatorEnum.IsNot():
            lFunc = IsNotFunc;
            break;
        case mRelationalOperatorEnum.In():
            lFunc = InFunc;
            break;
        case mRelationalOperatorEnum.NotIn():
            lFunc = NotInFunc;
            break;
        case mRelationalOperatorEnum.Contains():
            lFunc = ContainsFunc;
            break;
        default:
            throw('invalid operator in expression');
    }

    this.Evaluate = function (aObject) {
        if (isNullOrUndefined(aObject)) {
            console.log('error');
        } else {
            return lFunc(aObject[this.Name], this.Value);
        }

    };

//    this.ToString = function (aObjectName) {
//        var lReturnValue = "";
//        if (this.Name !== null && this.Value !== null) {
//            if (this.Operator !== mRelationalOperatorEnum.Like() && this.Operator !== mRelationalOperatorEnum.In() && this.Operator !== mRelationalOperatorEnum.NotIn()) {
//                if (typeof this.Value === 'string') {
//                    lReturnValue += aObjectName;
//                    lReturnValue += "['";
//                    lReturnValue += this.Name;
//                    lReturnValue += "'] ";
//                    lReturnValue += GetRelationalOperatorString(this.Operator);
//                    lReturnValue += " ";
//                    lReturnValue += "'";
//                    lReturnValue += this.Value;
//                    lReturnValue += "'";
//                } else {
//                    lReturnValue += aObjectName;
//                    lReturnValue += "['";
//                    lReturnValue += this.Name;
//                    lReturnValue += "'] ";
//                    lReturnValue += GetRelationalOperatorString(this.Operator);
//                    lReturnValue += " ";
//                    lReturnValue += this.Value;
//                }
//            } else if (this.Operator === mRelationalOperatorEnum.Like()) {
//                lReturnValue += "(";
//                lReturnValue += aObjectName;
//                lReturnValue += "['";
//                lReturnValue += this.Name;
//                lReturnValue += "']";
//                lReturnValue += " !== null && (";
//                lReturnValue += aObjectName;
//                lReturnValue += "['";
//                lReturnValue += this.Name;
//                lReturnValue += "'].toLowerCase()).indexOf('";
//                lReturnValue += this.Value.toLowerCase();
//                lReturnValue += "') !== -1)";
//            } else {
//                if (typeof this.Value === 'object') {
//                    lReturnValue += this.Value;
//                } else {
//                    lReturnValue += '"';
//                    lReturnValue += this.Value;
//                    lReturnValue += '"';
//                }
//                lReturnValue += ".indexOf(eval(\"'\" + ";
//                lReturnValue += aObjectName;
//                lReturnValue += "['";
//                lReturnValue += this.Name;
//                lReturnValue += "']";
//                lReturnValue += " + \"'\")) ";
//                lReturnValue += GetRelationalOperatorString(this.Operator);
//                lReturnValue += " -1";
//            }
//        }
//        return lReturnValue;
//    };
}

function SumoPredicateBuilder() {
    /// <summary>SumoPredicateBuilder provides query predicate construction services. The query predicates are compatible with the server side (vb.net) Sumo ORM library.</summary>
    "use strict";

    this.RootExpression = null;

    this.Clear = function () {
        this.RootExpression = null;
    };

    this.AddConditional = function (aExpressionConditional, aLogicalOperator) {
        /// <summary>SumoPredicateBuilder.AddConditional: add an existing conditional expression to the predicate.</summary>
        /// <param name="aExpressionConditional" type="ExpressionConditional" Optional="false">an existing conditional expression</param>
        /// <param name="aLogicalOperator" type="LogicalOperatorEnum" Optional="true">A logical operator enum in the form mLogicalOperatorEnum.And() or mLogicalOperatorEnum.Or(). If not </param>
        if (this.RootExpression === null) {
            this.RootExpression = aExpressionConditional;
        } else {
            if (typeof aLogicalOperator === 'undefined' || aLogicalOperator === null) {
                aLogicalOperator = mLogicalOperatorEnum.And();
            }
            this.RootExpression = new ExpressionBinary(this.RootExpression, aExpressionConditional, aLogicalOperator);
        }
    };

    this.AddNewExpressionConditional = function (aName, aValue, aIsLiteral, aRelationalOperator, aLogicalOperator) {
        var lNewLeaf,
            lBuilder,
            lSliceCount = 0,
            i,
            lInExpression;
        if (typeof aIsLiteral === 'undefined' || aIsLiteral === null) {
            aIsLiteral = false;
        }
        if (typeof aRelationalOperator === 'undefined' || aRelationalOperator === null || aRelationalOperator === mRelationalOperatorEnum.Undefined()) {
            aRelationalOperator = mRelationalOperatorEnum.Equal();
        }
        if (typeof aLogicalOperator === 'undefined' || aLogicalOperator === null || aLogicalOperator === mLogicalOperatorEnum.Undefined()) {
            aLogicalOperator = mLogicalOperatorEnum.And();
        }
        if (aRelationalOperator === mRelationalOperatorEnum.NotIn() || aRelationalOperator === mRelationalOperatorEnum.In()) {
            if (aValue.length > 1000) {
                lBuilder = new SumoPredicateBuilder();
                lSliceCount = Math.ceil(aValue.length / 1000);
                for (i = 0; i < lSliceCount; i++) {
                    lInExpression = aValue.slice(i * 1000, (i + 1) * 1000);
                    lBuilder.AddNewExpressionConditional(aName, lInExpression, aIsLiteral, aRelationalOperator, mLogicalOperatorEnum.Or());
                }
                this.Concatenate(lBuilder, aLogicalOperator);
            } else {
                lNewLeaf = new ExpressionConditional(aName, aValue, aIsLiteral, aRelationalOperator);
                this.AddConditional(lNewLeaf, aLogicalOperator);
            }
        } else {
            lNewLeaf = new ExpressionConditional(aName, aValue, aIsLiteral, aRelationalOperator);
            this.AddConditional(lNewLeaf, aLogicalOperator);
        }
        //return lNewLeaf;
    };

    this.AddExpressionBinary = function (aExpression, aLogicalOperator) {
        if (typeof aLogicalOperator === 'undefined' || aLogicalOperator === null) {
            aLogicalOperator = mLogicalOperatorEnum.And();
        }
        if (isNullOrUndefined(this.RootExpression)) {
            this.RootExpression = aExpression;
        } else {
            this.RootExpression = new ExpressionBinary(this.RootExpression, aExpression, aLogicalOperator);
        }
        return this.RootExpression;
    };

    this.Concatenate = function (aSumoPredicateBuilder, aLogicalOperator) {
        if (typeof aLogicalOperator === 'undefined' || aLogicalOperator === null) {
            aLogicalOperator = mLogicalOperatorEnum.And();
        }
        if (this.RootExpression === null) {
            this.RootExpression = aSumoPredicateBuilder.RootExpression;
        } else {
            this.RootExpression = new ExpressionBinary(this.RootExpression, aSumoPredicateBuilder.RootExpression, aLogicalOperator);
        }
    };
}

function evaluateExpressionValue(aExpression, aPropertyName) {
    "use strict";
    var lResult = [];

    function evaluate(aConditionalExpression, aPropertyName) {
        if (aConditionalExpression.Name === aPropertyName) {
            lResult.push(aConditionalExpression);
        }
    }

    function evaluateExpression(aEvaluatedExpression, aPropertyName) {
        if (aEvaluatedExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
            evaluateExpression(aEvaluatedExpression.LeftOperand, aPropertyName);
            evaluateExpression(aEvaluatedExpression.RightOperand, aPropertyName);
        } else {
            evaluate(aEvaluatedExpression, aPropertyName);
        }
    }

    if (!isNullOrUndefined(aExpression)) {
        evaluateExpression(aExpression, aPropertyName);
    }
    return lResult;
}

function removeExpressionValue(aExpression, aPropertyName) {
    var lBuilder = new SumoPredicateBuilder();

    function evaluate(aConditionalExpression) {
        var lIsInvalid = false;

        if (['array', 'object'].indexOf(typeof aPropertyName) !== -1) {
            lIsInvalid = (aPropertyName.indexOf(aConditionalExpression.Name) !== -1);
        } else {
            lIsInvalid = (aConditionalExpression.Name === aPropertyName);
        }

        if (!lIsInvalid) {
            lBuilder.AddConditional(aConditionalExpression);
        }
    }

    function evaluateExpression(aEvaluatedExpression) {
        if (aEvaluatedExpression.__type === 'ExpressionBinary:www.sumosoftware.com/Expressions') {
            evaluateExpression(aEvaluatedExpression.LeftOperand);
            evaluateExpression(aEvaluatedExpression.RightOperand);
        } else {
            evaluate(aEvaluatedExpression);
        }
    }

    evaluateExpression(aExpression);

    return lBuilder.RootExpression;
}

// Get true object length //
function ObjectLength(aObject) {
    "use strict";
    var lKey,
        length = 0;

    for (lKey in aObject) {
        if (aObject.hasOwnProperty(lKey)) {
            length++;
        }
    }

    return length;
}
function ReadPaginated(aFullTypeName, aExpression, aVersion, aOnSuccess, aOnFailure, aOutParams, aSortExpression, aDoCheckState,aPageNumber, aPageSize) {
    /// <summary>ReadPaginated: read multiple records from the server using a paginated query.</summary>
    "use strict";
    var lSortExpression = null,
        lSecurityToken = veritracks.security.controller.tryGetSecurityToken(),
        lRecordCount = -1,
        lDoCheckState = true;
    if (!isNullOrUndefined(lSecurityToken) && lSecurityToken != "") {
        const lSortExpression = aSortExpression || null;
        const lDoCheckState = aDoCheckState || true;
        // const lPageNumber = aPageNumber || 0;
        // const lPageSize = aPageSize || 1000;
        callAjax('ReadPaginated', {
            'aSecurityToken': lSecurityToken,
            'aSecurityContextId': -1,
            'aTypeName': aFullTypeName,
            'aVersion': aVersion,
            'aWrappedExpression': { 'Expression': aExpression },
            'aSortExpression': lSortExpression,
            'aPageNumber': aPageNumber,
            'aPageSize': aPageSize,
        }, aOnSuccess, aOnFailure, aOutParams, lDoCheckState);
    }
}

if (typeof exports !== 'undefined') {
    module.exports = {"Date":Date,"Number":Number,"Array":Array,ReleaseLockMultiple,ReleaseLockSingle,ExtendLockMultiple,ExtendLockSingle,LockMultiple,LockSingle,ExtendServerSession,ExpireServerSession,IsAuthorized,WriteMultiple,Execute,WriteSingle,WriteUserSMSDeliveryMethod,ReadMultiple,CheckSessions,LogUserAgreement,GetBillingInfo,RefreshCacheItem,WriteGlobalZone,WriteGlobalZonePQ,UpdateZones,WriteVictimDeviceUnAssignment,WriteVictimDeviceUnAssignmentPR,WriteVictimDeviceAssignment,WriteVictimDeviceAssignmentPR,GetObjectList,WriteUserPassword,WriteLogUserTransaction,GetBluHomeCommandStatus,GetEMAEnrolleeStatus,GetEMACheckInSchedule,GetEMAChangeRequest,GetEMAMessagePending,GetEMACheckInEvent,GetPlacesRequest,GetRefreshedZones,WriteEnrolleeAudibleOnLowBatt,GetEIdReservationQuota,GetIcons,GenerateIconsPng,GetOffenderAlcoholLastTest,ReverseGeoCodeAddress,GeoCodeAddress,GetOffenderAlcoholSchedules,GetOriDeviceChangeReason,GetOriSexOffense,GetDeviceContact,GetNonCacheItem,FixDates,fixDate,prepareObjectForWcf,SerializationSettings,SortColumn:(typeof SortColumn!=="undefined"?SortColumn:undefined),SortExpression:(typeof SortExpression!=="undefined"?SortExpression:undefined),GrepExample,query,LogicalOperatorEnum,RelationalOperatorEnum,ExpressionBinary,ExpressionConditional,SumoPredicateBuilder,evaluateExpressionValue,removeExpressionValue,ObjectLength,ReadPaginated};
}